var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-modal',{attrs:{"id":"promote-milestone-modal","footer-primary-button-variant":"warning","footer-primary-button-text":_vm.s__('Milestones|Promote Milestone')},on:{"submit":_vm.onSubmit}},[_c('template',{slot:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c645938e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/milestones/shared/components/promote_milestone_modal.vue
// module id = null
// module chunks = 